import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import AppRoutes from './router';
import MobileHeader from './components/sidebar/MobileHeader';
import { useTheme } from './context/ThemeContext';
import SidebarWrapper from './components/sidebar/SidebarWrapper';
import ErrorBoundary from './components/shared/ErrorBoundry';
import ErrorHandler from './components/shared/ErrorHandler';

const queryClient = new QueryClient();

function App() {
  const { theme } = useTheme();
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ErrorBoundary>
          <MobileHeader />
          <ErrorHandler />
          <div className="App flex w-full h-auto">
            {!theme.hideSidebarPermanently && <SidebarWrapper />}
            <div className={`w-full ${theme['bg-default']}`}>
              <AppRoutes />
            </div>
          </div>
        </ErrorBoundary>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
